import React, { useEffect, useState } from "react";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  Upload,
  message,
  Collapse,
  Modal,
  InputNumber,
  AutoComplete,
  Image,
  Tag,
  Spin,
} from "antd";
import { UploadOutlined, SearchOutlined, ThunderboltOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { toastNotification } from "../../../utils/toastNotification";
import Api from "../../../api";

import "../../../public/sass/components/drawer/positions/_positions.scss";
import "../../../public/sass/components/drawer/_createDrawers.scss";
import ProductsModal from "../../Modals/ProductsModal";
import ApiConstants from "../../../api/ApiConstants";
import Edit from "../../../public/images/dashboard/tables/edit.svg";

//Upload picture
// const props = {
//   name: "file",
//   action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
//   headers: {
//     authorization: "authorization-text",
//   },
//   onChange(info) {
//     if (info.file.status !== "uploading") {
//       console.log(info.file, info.fileList);
//     }
//     if (info.file.status === "done") {
//       message.success(`${info.file.name} file uploaded successfully`);
//     } else if (info.file.status === "error") {
//       message.error(`${info.file.name} file upload failed.`);
//     }
//   },
// };

//declared but never been used const props = {}

const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

export const EditPosition = ({
  isVisible,
  editData,
  id,
  onClose,
  handleGetAllProducts,
  reloadProducts,
  companies,
  third_parties,
  categories,
  products,
  pageSize,
  currentPage,
}) => {
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  const [checkValueSelect, setValueSelect] = useState("Freie Masse");
  const [checkData, setCheckedData] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [is_breakdown_value, setBreakDown] = useState(false);
  const [is_going_concern_value, setGoingConcern] = useState(false);
  const [is_market_value, setMarkDown] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [fileListData, setFileList] = useState([]);
  const [words, setWords] = useState([]);
  const [nameAddress, setNameAddress] = useState();

  const userRole = localStorage.getItem("user_role");
  const userPermissions = JSON.parse(localStorage.getItem("user_permissions") || "[]");
  const hasAiPermission = userPermissions.includes("AIPricing") || userPermissions.includes("AIPricingGenerate");

  const [aiLoading, setAiLoading] = useState(false);
  const [aiResult, setAiResult] = useState(null);
  const [aiExpanded, setAiExpanded] = useState(false);
  useEffect(() => {
    handleGetAllWords();
  }, []);

  useEffect(() => {
    if (isVisible) {
      setAiResult(null);
      setAiExpanded(false);

      let response = { ...editData };
      Object.keys(response).map((key) => {
        if (response[key] == "undefined") {
          response[key] = "";
        }
      });

      const filePDFs = response?.pdfs;
      setValueSelect(response.rights);

      if (filePDFs) {
        const pdfs = JSON.parse(filePDFs);
        let objPDF = {};
        objPDF.uid = editData?.id;
        objPDF.name = pdfs[0];
        objPDF.status = "done";
        objPDF.url = ApiConstants.FILE_URL + pdfs[0];

        setFileList((fileListData) => [objPDF, ...fileListData]);
      }

      return form.setFieldsValue(response);
    }

    return () => {
      setFileList([]);
    };
  }, [isVisible]);

  const handleSubmit = (formValues) => {
    Api("products/" + id, "PATCH", formValues)
      .then(() => {
        setEdit(false);
        toastNotification("success", `${t("product_created_successfully")}`);
        reloadProducts();
        setValueSelect("Freie Masse");
        form.resetFields();
        onClose();
      })
      .catch((err) => {
        toastNotification(
          "error",
          err.error || `${t("error_create_products")}`
        );
      });
  };

  const handleGetAllWords = () => {
    Api(`words`, "GET", null)
      .then((data) => {
        setWords(data?.results);
      })
      .catch(() => setLoading(false));
  };
  const test = { nameee: companies?.name };

  const changeAddresses = () => {
    const obj = companies.find((item) => item?.id == editData.action_id);
    setNameAddress(obj.name);
    setAddresses(obj?.addresses);
  };

  const aussonderung = [
    { key: "Fremdeigentum", value: "Fremdeigentum" },
    {
      key: "Einfacher Eigentumsvorbehalt",
      value: "Einfacher Eigentumsvorbehalt",
    },
    { key: "Leasing", value: "Leasing" },
    { key: "Miete", value: "Miete" },
    { key: "Mietkauf", value: "Mietkauf" },
    {
      key: "Sonstiges (mit Möglichkeit händischer Eingabe)",
      value: "Sonstiges (mit Möglichkeit händischer Eingabe)",
    },
  ];

  const absonderung = [
    {
      key: "Finanzierung/Darlehenssicherung",
      value: "Finanzierung/Darlehenssicherung",
    },
    { key: "Sicherungsübereignung", value: "Sicherungsübereignung" },
    { key: "Raumsicherungsübereignung", value: "Raumsicherungsübereignung" },
    { key: "Mietkauf", value: "Mietkauf" },
    { key: "Vermieterpfandrecht", value: "Vermieterpfandrecht" },
    {
      key: "erweiterter/verlängerter Eigentumsvorbehalt",
      value: "erweiterter/verlängerter Eigentumsvorbehalt",
    },
    {
      key: "Sonstiges (mit Möglichkeit händischer Eingabe)",
      value: "Sonstiges (mit Möglichkeit händischer Eingabe)",
    },
  ];

  //Upload picture
  const props = {
    name: "file",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };


  const onReset = () => {
    setEdit(false);
    setValueSelect("Freie Masse");
    onClose();
    form.resetFields();
  };

  const handleCalculations = (_, values) => {
    const breakdown_value = values?.breakdown_value || 0;
    const going_concern_value = values?.going_concern_value || 0;
    const market_value = values?.market_value || 0;

    const bv_quantity = values?.bv_quantity || 0;
    const gcv_quantity = values?.gcv_quantity || 0;
    const mv_quantity = values?.mv_quantity || 0;

    const bv_tax_type = values?.bv_tax_type || 19;
    const gcv_tax_type = values?.gcv_tax_type || 19;
    const mv_tax_type = values?.mv_tax_type || 19;

    const calculatePercentMinus = Math.round(
      (bv_tax_type / 100) * breakdown_value * bv_quantity
    );

    const calculatePercentPlus = Math.round(
      breakdown_value * bv_quantity + calculatePercentMinus
    );

    const calculatePercentMinusGC = Math.round(
      (gcv_tax_type / 100) * going_concern_value * gcv_quantity
    );

    const calculatePercentPlusGC = Math.round(
      going_concern_value * gcv_quantity + calculatePercentMinusGC
    );

    const calculatePercentMinusMV = Math.round(
      (mv_tax_type / 100) * market_value * mv_quantity
    );

    const calculatePercentPlusMV = Math.round(
      market_value * mv_quantity + calculatePercentMinusMV
    );

    form.setFieldsValue({
      ...values,
      bv_subtotal: breakdown_value * bv_quantity,
      gcv_subtotal: going_concern_value * gcv_quantity,
      mv_subtotal: market_value * mv_quantity,
      bv_tax_costs: calculatePercentMinus,
      gcv_tax_costs: calculatePercentMinusGC,
      mv_tax_costs: calculatePercentMinusMV,
      bv_tax_total: calculatePercentPlus,
      gcv_tax_total: calculatePercentPlusGC,
      mv_tax_total: calculatePercentPlusMV,
    });
  };

  const onPressSearchItem = (item, type) => {
    if (type === "breakdown_value") {
      form.setFieldsValue({
        breakdown_value: item?.breakdown_value,
        bv_quantity: item?.bv_quantity || 1,
        bv_subtotal: item?.bv_subtotal || 1,
        bv_tax_type: item?.bv_tax_type || 19,
        bv_tax_costs: item?.bv_tax_costs,
        bv_tax_total: item?.bv_tax_total,
      });

      setBreakDown(!is_breakdown_value);
    } else if (type === "going_concern_value") {
      form.setFieldsValue({
        going_concern_value: item?.going_concern_value,
        gcv_quantity: item?.gcv_quantity || 1,
        gcv_subtotal: item?.gcv_subtotal || 1,
        gcv_tax_type: item?.gcv_tax_type || 19,
        gcv_tax_costs: item?.gcv_tax_costs,
        gcv_tax_total: item?.gcv_tax_total,
      });
      setGoingConcern(!is_going_concern_value);
    } else if (type === "market_value") {
      form.setFieldsValue({
        market_value: item?.market_value,
        mv_quantity: item?.mv_quantity || 1,
        mv_subtotal: item?.mv_subtotal || 1,
        mv_tax_type: item?.mv_tax_type || 19,
        mv_tax_costs: item?.mv_tax_costs,
        mv_tax_total: item?.mv_tax_total,
      });
      setMarkDown(!is_market_value);
    } else {
      message.info("Something went wrong, please try again");
    }

    message.info("Gerade hinzugefügt " + item?.name);
  };

  const generateAiPricing = () => {
    setAiLoading(true);
    setAiExpanded(true);
    const formValues = form.getFieldsValue();
    Api("ai/pricing/generate", "POST", {
      productId: id,
      name: formValues.name,
      short_description: formValues.short_description,
      long_description: formValues.long_description,
    })
      .then((data) => {
        setAiResult(data);
        form.setFieldsValue({
          ai_pricing_response: data.product?.ai_pricing_response || undefined,
          breakdown_value: data.product?.breakdown_value ? Number(data.product.breakdown_value) : undefined,
          going_concern_value: data.product?.going_concern_value ? Number(data.product.going_concern_value) : undefined,
          market_value: data.product?.market_value ? Number(data.product.market_value) : undefined,
          breakdown_value_source: data.product?.breakdown_value_source || 'ai',
          going_concern_value_source: data.product?.going_concern_value_source || 'ai',
          market_value_source: data.product?.market_value_source || 'ai',
          bv_quantity: data.product?.bv_quantity ? Number(data.product.bv_quantity) : 1,
          bv_subtotal: data.product?.bv_subtotal ? Number(data.product.bv_subtotal) : undefined,
          bv_tax_type: data.product?.bv_tax_type ? Number(data.product.bv_tax_type) : 19,
          bv_tax_costs: data.product?.bv_tax_costs ? Number(data.product.bv_tax_costs) : undefined,
          bv_tax_total: data.product?.bv_tax_total ? Number(data.product.bv_tax_total) : undefined,
          gcv_quantity: data.product?.gcv_quantity ? Number(data.product.gcv_quantity) : 1,
          gcv_subtotal: data.product?.gcv_subtotal ? Number(data.product.gcv_subtotal) : undefined,
          gcv_tax_type: data.product?.gcv_tax_type ? Number(data.product.gcv_tax_type) : 19,
          gcv_tax_costs: data.product?.gcv_tax_costs ? Number(data.product.gcv_tax_costs) : undefined,
          gcv_tax_total: data.product?.gcv_tax_total ? Number(data.product.gcv_tax_total) : undefined,
          mv_quantity: data.product?.mv_quantity ? Number(data.product.mv_quantity) : 1,
          mv_subtotal: data.product?.mv_subtotal ? Number(data.product.mv_subtotal) : undefined,
          mv_tax_type: data.product?.mv_tax_type ? Number(data.product.mv_tax_type) : 19,
          mv_tax_costs: data.product?.mv_tax_costs ? Number(data.product.mv_tax_costs) : undefined,
          mv_tax_total: data.product?.mv_tax_total ? Number(data.product.mv_tax_total) : undefined,
        });
        toastNotification("success", t("ai_pricing") + " " + t("success"));
      })
      .catch((err) => {
        toastNotification("error", err?.message || t("error"));
      })
      .finally(() => setAiLoading(false));
  };

  const handleAiApprove = () => {
    const formValues = form.getFieldsValue();
    Api("products/" + id + "/validate", "PATCH", {
      status: "approved",
      breakdown_value: formValues.breakdown_value,
      going_concern_value: formValues.going_concern_value,
      market_value: formValues.market_value,
    })
      .then(() => {
        toastNotification("success", t("ai_approved"));
        setAiResult({ ...aiResult, product: { ...aiResult?.product, validation_status: "approved" } });
        reloadProducts();
      })
      .catch((err) => toastNotification("error", err?.message || t("error")));
  };

  const handleAiReject = () => {
    Api("products/" + id + "/validate", "PATCH", { status: "rejected" })
      .then(() => {
        toastNotification("success", t("ai_rejected"));
        setAiResult({ ...aiResult, product: { ...aiResult?.product, validation_status: undefined } });
        reloadProducts();
      })
      .catch((err) => toastNotification("error", err?.message || t("error")));
  };

  const renderConfidenceTag = (confidence) => {
    if (confidence === null || confidence === undefined) return null;
    const color = confidence >= 80 ? "green" : confidence >= 60 ? "orange" : "red";
    return <Tag color={color} style={{ fontSize: 11 }}>{confidence}%</Tag>;
  };

  const aiPriceData = aiResult?.product || editData;
  const hasAiData = aiPriceData?.ai_confidence_breakdown !== undefined && aiPriceData?.ai_confidence_breakdown !== null;

  const validateMessages = {
    required: `${t("field_required")}`,
  };

  return (
    <Drawer
      width={720}
      onClose={onReset}
      visible={isVisible}
      title={t("edit_position")}
      className="body-style"
      footer={
        <div className="footer-style">
          <Button disabled={!isEdit} onClick={onReset} className="button-style">
            {t("cancel")}
          </Button>
          <Button
            disabled={!isEdit}
            type="primary"
            form="positions-form"
            key="submit"
            htmlType="submit"
          >
            {t("submit")}
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        validateMessages={validateMessages}
        id="positions-form"
        initialValues={{
          short_description: "",
          long_description: "",
          is_incomplete: false,
        }}
        layout="vertical"
        scrollToFirstError
        onFinish={handleSubmit}
        onValuesChange={handleCalculations}
        className="form-style"
      >
        <Row gutter={16}>
          <Col span={22}></Col>
          <Col span={2} style={{ flexDirection: "row", display: "flex" }}>
            <a onClick={() => setEdit(true)}>
              <img src={Edit} alt="Edit" />
            </a>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="name"
              label={t("product_name")}
              rules={[{ required: true }]}
              labelAlign="left"
            >
              <AutoComplete
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) === 0
                }
                disabled={!isEdit}
              >
                {words.map((item) => (
                  <Option key={item.id} value={item.name}>
                    {item.name}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="inventar_id"
              label={t("inventory_number")}
              rules={[{ required: false }]}
              labelAlign="left"
            >
              <Input placeholder="" disabled={!isEdit} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="product_id"
              label={t("product_number")}
              rules={[{ required: true }]}
              labelAlign="left"
            >
              <Input placeholder="" type="number" disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="short_description"
              label={t("short_description")}
              labelAlign="left"
            >
              <TextArea
                rows={3}
                placeholder=""
                showCount
                maxLength={250}
                disabled={!isEdit}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="long_description"
              label={t("description")}
              labelAlign="left"
            >
              <TextArea rows={3} placeholder="" disabled={!isEdit} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="category_id"
              label={t("category")}
              rules={[{ required: true }]}
              labelAlign="left"
            >
              <Select
                placeholder={t("")}
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                disabled={!isEdit}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) === 0
                }
              >
                {categories?.map((item, idx) => (
                  <Option key={idx} value={item?.id}>
                    {item?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="packaging_unit"
              label={t("packaging_unit")}
              rules={[{ required: false }]}
              labelAlign="left"
            >
              <Select
                placeholder="Stück"
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                disabled={!isEdit}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) === 0
                }
              >
                <Option value="Piece">{t("piece")}</Option>
                <Option value="Litre">{t("litre")}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="packaging_unit_qty"
              label={t("qty_packaging_unit")}
              rules={[{ required: false }]}
              labelAlign="left"
            >
              {/* <Input placeholder="" type="number" /> */}
              <InputNumber
                disabled={!isEdit}
                placeholder=""
                min={0}
                controls={false}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="mileage"
              label={t("mileage")}
              // rules={[{ required: true }]}
              labelAlign="left"
            >
              <Input placeholder="50000" disabled={!isEdit} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="mileage_type"
              label={t("type_of_mileage")}
              // rules={[{ required: true }]}
              labelAlign="left"
            >
              <Select
                placeholder="km"
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                disabled={!isEdit}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) === 0
                }
              >
                <Option value="km">km</Option>
                <Option value="h">h</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="assessment_type"
              label={t("assessment_type")}
              rules={[{ required: true }]}
              labelAlign="left"
            >
              <Select
                placeholder={t("assessment")}
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                disabled={!isEdit}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) === 0
                }
              >
                <Option value="assessment">{t("assessment")}</Option>
                <Option value="desktop_assessment">
                  {t("desktop_assessment")}
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {hasAiPermission && (
          <div className="ai-pricing-section">
            <Row align="middle">
              <Col flex="auto">
                <strong style={{ fontSize: 15 }}>{t("ai_pricing")}</strong>
              </Col>
              <Col>
                <Button
                  type="primary"
                  icon={<ThunderboltOutlined />}
                  onClick={generateAiPricing}
                  loading={aiLoading}
                  disabled={!isEdit}
                >
                  {hasAiData && !aiLoading ? t("regenerate") : t("ai_generate")}
                </Button>
              </Col>
              {aiLoading && (
                <Col>
                  <Spin size="small" style={{ marginLeft: 8 }} />
                </Col>
              )}
            </Row>

            {aiPriceData && hasAiData && (
              <>
                <Row gutter={16} style={{ marginTop: 16 }}>
                  {[
                    { label: t("breakdown_value"), value: aiPriceData.breakdown_value, confidence: aiPriceData.ai_confidence_breakdown },
                    { label: t("going_concern_value"), value: aiPriceData.going_concern_value, confidence: aiPriceData.ai_confidence_going_concern },
                    { label: t("market_value"), value: aiPriceData.market_value, confidence: aiPriceData.ai_confidence_market },
                  ].map((item, idx) => (
                    <Col span={8} key={idx}>
                      <div style={{ background: "#fff", padding: "12px 8px", borderRadius: 4, textAlign: "center" }}>
                        <div style={{ fontSize: 12, color: "#888", marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {item.label}
                        </div>
                        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
                          {item.value ? `€${Number(item.value).toLocaleString()}` : "-"}
                        </div>
                        <div>{renderConfidenceTag(item.confidence)}</div>
                      </div>
                    </Col>
                  ))}
                </Row>

                {aiPriceData.ai_reasoning && (
                  <div style={{ background: "#fff", padding: 12, borderRadius: 4, marginTop: 12 }}>
                    <div style={{ fontWeight: 600, marginBottom: 6, fontSize: 13 }}>{t("ai_reasoning")}</div>
                    <div style={{ fontSize: 13, color: "#555", whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
                      {(() => {
                        try {
                          const parsed = JSON.parse(aiPriceData.ai_reasoning);
                          return Object.entries(parsed)
                            .map(([k, v]) => `${k}: ${v}`)
                            .join("\n");
                        } catch {
                          return aiPriceData.ai_reasoning;
                        }
                      })()}
                    </div>
                  </div>
                )}

                {aiPriceData.validation_status === "pending" && (
                  <Row gutter={16} style={{ marginTop: 16 }} justify="center">
                    <Col>
                      <Button type="primary" icon={<CheckOutlined />} onClick={handleAiApprove}>
                        {t("ai_approve")}
                      </Button>
                    </Col>
                    <Col>
                      <Button danger icon={<CloseOutlined />} onClick={handleAiReject}>
                        {t("ai_reject")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </>
            )}

            {aiPriceData && aiPriceData.validation_status === "approved" && (
              <Tag color="green" style={{ marginTop: 8 }}>{t("ai_approved")}</Tag>
            )}
            {aiPriceData && aiPriceData.validation_status === "auto_approved" && (
              <Tag color="blue" style={{ marginTop: 8 }}>{t("auto_approved")}</Tag>
            )}
          </div>
        )}

        {userRole != "Data Creator" && (
          <Collapse bordered={false} className="collapse-style">
            <Panel
              header={
                <>
                  <div>
                    <Row
                      gutter={16}
                      className="row-style-collapse"
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    >
                      <Col span={10}>
                        <div className="panel__row__style">
                          <p className="header-text">{t("breakdown_value")}</p>
                          <Button
                            onClick={() => setBreakDown(!is_breakdown_value)}
                            className="panel__row__style--icon"
                            shape="square"
                            icon={<SearchOutlined />}
                          />
                        </div>
                      </Col>

                      <Col span={14}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Form.Item
                            name="breakdown_value"
                            rules={[{ required: true }]}
                            style={{ flex: 1, marginBottom: 0 }}
                          >
                            <InputNumber
                              placeholder=""
                              min={0}
                              controls={false}
                              style={{ width: "100%" }}
                              disabled={!isEdit}
                            />
                          </Form.Item>
                          {form.getFieldValue("breakdown_value_source") === "manual" ? (
                            <Tag color="green" style={{ flexShrink: 0, marginLeft: 8 }}>Manual</Tag>
                          ) : form.getFieldValue("ai_pricing_response") ? (
                            <Tag color="blue" style={{ flexShrink: 0, marginLeft: 8 }}>AI</Tag>
                          ) : null}
                        </div>
                        <Modal
                          visible={is_breakdown_value}
                          onOk={() => setBreakDown(!is_breakdown_value)}
                          onCancel={() => setBreakDown(!is_breakdown_value)}
                        >
                          <ProductsModal
                            onPressSearchItem={onPressSearchItem}
                            type="breakdown_value"
                          />
                        </Modal>
                      </Col>
                    </Row>
                  </div>
                </>
              }
              key="1"
              className="panel-style"
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="bv_quantity"
                    label={t("quantity")}
                    rules={[{ required: true }]}
                    labelAlign="left"
                  >
                    <InputNumber
                      placeholder=""
                      min={0}
                      controls={false}
                      style={{ width: "100%" }}
                      disabled={!isEdit}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="bv_subtotal"
                    label={t("subtotal")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="bv_tax_type"
                    label={t("tax_type")}
                    rules={[{ required: true }]}
                    labelAlign="left"
                  >
                    <Select
                      showSearch={true}
                      searchBy="label"
                      optionFilterProp="children"
                      disabled={!isEdit}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) === 0
                      }
                    >
                      <Option value="19">19%</Option>
                      <Option value="7">7%</Option>
                      <Option value="0">0%</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="bv_tax_costs"
                    label={t("tax_costs")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="bv_tax_total"
                    label={t("total_incl_tax")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
            <Panel
              header={
                <>
                  <div>
                    <Row
                      gutter={16}
                      className="row-style-collapse"
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    >
                      <Col span={10}>
                        <div className="panel__row__style">
                          <p className="header-text">
                            {t("going_concern_value")}
                          </p>
                          <Button
                            onClick={() =>
                              setGoingConcern(!is_going_concern_value)
                            }
                            className="panel__row__style--icon"
                            shape="square"
                            icon={<SearchOutlined />}
                          />
                        </div>
                      </Col>

                      <Col span={14}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Form.Item rules={[{ required: true }]} name="going_concern_value" style={{ flex: 1, marginBottom: 0 }}>
                            <InputNumber
                              placeholder=""
                              min={0}
                              controls={false}
                              style={{ width: "100%" }}
                              disabled={!isEdit}
                            />
                          </Form.Item>
                          {form.getFieldValue("going_concern_value_source") === "manual" ? (
                            <Tag color="green" style={{ flexShrink: 0, marginLeft: 8 }}>Manual</Tag>
                          ) : form.getFieldValue("ai_pricing_response") ? (
                            <Tag color="blue" style={{ flexShrink: 0, marginLeft: 8 }}>AI</Tag>
                          ) : null}
                        </div>
                        <Modal
                          visible={is_going_concern_value}
                          onOk={() => setGoingConcern(!is_going_concern_value)}
                          onCancel={() =>
                            setGoingConcern(!is_going_concern_value)
                          }
                        >
                          <ProductsModal
                            onPressSearchItem={onPressSearchItem}
                            type="going_concern_value"
                          />
                        </Modal>
                      </Col>
                    </Row>
                  </div>
                </>
              }
              key="2"
              className="panel-style"
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="gcv_quantity"
                    label={t("quantity")}
                    labelAlign="left"
                  >
                    <InputNumber
                      placeholder=""
                      min={0}
                      controls={false}
                      style={{ width: "100%" }}
                      disabled={!isEdit}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="gcv_subtotal"
                    label={t("subtotal")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="gcv_tax_type"
                    label={t("tax_type")}
                    labelAlign="left"
                  >
                    <Select
                      showSearch={true}
                      searchBy="label"
                      optionFilterProp="children"
                      disabled={!isEdit}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) === 0
                      }
                    >
                      <Option value="19">19%</Option>
                      <Option value="7">7%</Option>
                      <Option value="0">0%</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="gcv_tax_costs"
                    label={t("tax_costs")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="gcv_tax_total"
                    label={t("total_incl_tax")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
            <Panel
              header={
                <>
                  <div>
                    <Row
                      gutter={16}
                      className="row-style-collapse"
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    >
                      <Col span={10}>
                        <div className="panel__row__style">
                          <p className="header-text">{t("market_value")}</p>
                          <Button
                            onClick={() => setMarkDown(!is_market_value)}
                            className="panel__row__style--icon"
                            shape="square"
                            icon={<SearchOutlined />}
                          />
                        </div>
                      </Col>

                      <Col span={14}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Form.Item name="market_value" style={{ flex: 1, marginBottom: 0 }}>
                            <InputNumber
                              placeholder=""
                              min={0}
                              controls={false}
                              style={{ width: "100%" }}
                              disabled={!isEdit}
                            />
                          </Form.Item>
                          {form.getFieldValue("market_value_source") === "manual" ? (
                            <Tag color="green" style={{ flexShrink: 0, marginLeft: 8 }}>Manual</Tag>
                          ) : form.getFieldValue("ai_pricing_response") ? (
                            <Tag color="blue" style={{ flexShrink: 0, marginLeft: 8 }}>AI</Tag>
                          ) : null}
                        </div>
                        <Modal
                          visible={is_market_value}
                          onOk={() => setMarkDown(!is_market_value)}
                          onCancel={() => setMarkDown(!is_market_value)}
                        >
                          <ProductsModal
                            onPressSearchItem={onPressSearchItem}
                            type="market_value"
                          />
                        </Modal>
                      </Col>
                    </Row>
                  </div>
                </>
              }
              key="3"
              className="panel-style"
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="mv_quantity"
                    label={t("quantity")}
                    labelAlign="left"
                  >
                    <InputNumber
                      placeholder=""
                      min={0}
                      controls={false}
                      style={{ width: "100%" }}
                      disabled={!isEdit}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="mv_subtotal"
                    label={t("subtotal")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="mv_tax_type"
                    label={t("tax_type")}
                    labelAlign="left"
                  >
                    <Select
                      showSearch={true}
                      searchBy="label"
                      optionFilterProp="children"
                      disabled={!isEdit}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) === 0
                      }
                    >
                      <Option value="19">19%</Option>
                      <Option value="7">7%</Option>
                      <Option value="0">0%</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="mv_tax_costs"
                    label={t("tax_costs")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="mv_tax_total"
                    label={t("total_incl_tax")}
                    labelAlign="left"
                  >
                    <Input placeholder="" disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
        )}
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name="status"
              label="Status"
              rules={[{ required: true }]}
              labelAlign="left"
            >
              <Select
                placeholder={t("choose_user_status")}
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                disabled={!isEdit}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) === 0
                }
              >
                <Option value={0}>{t("accepted")}</Option>
                <Option value={1}>{t("not_accepted")}</Option>
                <Option value={2}>{t("in_progress")}</Option>
                <Option value={3}>{t("done")}</Option>
                <Option value={4}>{t("not_active")}</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="comment"
              label={t("comment")}
              rules={[{ required: true }]}
              labelAlign="left"
            >
              <Select
                onChange={(e) => setCheckedData(e)}
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                disabled={!isEdit}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) === 0
                }
              >
                <Option value="Keine Bemerkung">{t("no_comment")}</Option>
                <Option value="Entsorgung">{t("disposal_e")}</Option>
                <Option value="Festeinbau">{t("fixed_installation")}</Option>
                <Option value="Immobilienangepasst">
                  {t("real_estate_adapted")}
                </Option>
                <Option value="Ohne Bewertung">{t("without_rating")}</Option>
                <Option value="Nicht Besichtigt">{t("not_visited")}</Option>
                <Option value="Zubehör zu Position „XYZ“">
                  Zubehör zu Position „XYZ“
                </Option>
                <Option value="Bewertung unter Position „XYZ“">
                  Bewertung unter Position „XYZ“
                </Option>
                <Option value="Sonstiges (mit Möglichkeit händischer Eingabe)">
                  Sonstiges (mit Möglichkeit händischer Eingabe)
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {checkData == "Zubehör zu Position „XYZ“" && (
          <>
            <Form.Item
              name="product_parent_id"
              label={t("position")}
              rules={[{ required: true }]}
              labelAlign="left"
            >
              <Select
                placeholder=""
                showSearch={true}
                searchBy="label"
                disabled={!isEdit}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) === 0
                }
              >
                {products?.map((product, idx) => (
                  <Option key={idx} value={product?.product_id}>
                    {product?.name || "nothing"}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </>
        )}
        {checkData == "Sonstiges (mit Möglichkeit händischer Eingabe)" && (
          <Form.Item
            name="other"
            label={t("other")}
            rules={[{ required: true }]}
            labelAlign="left"
          >
            <TextArea
              showCount
              maxLength={200}
              disabled={!isEdit}
            />
          </Form.Item>
        )}

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="asset_type"
              label={t("asset_type")}
              rules={[{ required: userRole != "Data Creator" }]}
              labelAlign="left"
            >
              <Select
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                disabled={!isEdit}
              >
                <Option value={12}>12 Grundstücke und Bauten</Option>
                <Option value={15}>15 Maschinen- u. techn. Anlagen</Option>
                <Option value={16}>
                  16 Betriebs- und Geschäftsausstattung{" "}
                </Option>
                <Option value={39}>39 Fuhrpark </Option>
                <Option value={23}>23 Roh-, Hilf- u. Betriebsstoffe</Option>
                <Option value={24}>24 Unfertige/Halbfertige Waren </Option>
                <Option value={25}>25 Fertige Erzeugnisse u. Waren</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <div className="rights-section">
          <Row>
            <Col span={24}>
              <Form.Item name="rights" label={t("rights")} labelAlign="left">
                <Select
                  onChange={(e) => setValueSelect(e)}
                  defaultActiveFirstOption={true}
                  showSearch={true}
                  searchBy="label"
                  optionFilterProp="children"
                  disabled={!isEdit}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) === 0
                  }
                >
                  <Option value="Freie Masse">Freie Masse</Option>
                  <Option value="Aussonderung">{t("disposal")}</Option>
                  <Option value="Absonderung">{t("segregation")}</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {checkValueSelect !== "Freie Masse" && (
            <>
              <Row>
                <Col span={24}>
                  <Form.Item
                    name={
                      checkValueSelect == "Aussonderung"
                        ? "disposal_rights"
                        : "segregation_rights"
                    }
                    label={
                      checkValueSelect == "Aussonderung"
                        ? t("disposal_rights")
                        : t("segregation_rights")
                    }
                    labelAlign="left"
                  >
                    <Select
                      showSearch={true}
                      searchBy="label"
                      optionFilterProp="children"
                      disabled={!isEdit}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) === 0
                      }
                    >
                      {checkValueSelect == "Aussonderung"
                        ? aussonderung.map((item, idx) => (
                            <Option key={idx} value={item?.key}>
                              {item?.value}
                            </Option>
                          ))
                        : absonderung.map((item, idx) => (
                            <Option key={idx} value={item?.key}>
                              {item?.value}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="third_party_id"
                    label={t("third_party")}
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                    labelAlign="left"
                  >
                    <Select
                      placeholder={t("")}
                      showSearch={true}
                      searchBy="label"
                      optionFilterProp="children"
                      disabled={!isEdit}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) === 0
                      }
                    >
                      {third_parties?.map((item, idx) => (
                        <Option key={idx} value={item?.id}>
                          {item?.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="files"
                    label={t("uploadfiles")}
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                    labelAlign="left"
                  >
                    <Upload
                      customRequest={({ file, onSuccess }) => {
                        setTimeout(() => {
                          onSuccess("ok");
                        }, 0);
                      }}
                      fileList={fileListData}
                      maxCount={1}
                    >
                      <Button icon={<UploadOutlined />}>
                        {t("uploadImage")}
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </div>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="product_address"
              label={t("address_from_product")}
              labelAlign="left"
            >
              <Select
                showSearch={true}
                searchBy="label"
                optionFilterProp="children"
                onClick={(e) => changeAddresses(e)}
                filterOption={(input, option) => {
                  console.log("input", input);
                  console.log("option", option);
                  return (
                    option.key.toLowerCase().indexOf(input.toLowerCase()) >=
                      0 ||
                    option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                disabled={!isEdit}
              >
                {addresses?.map((item, idx) => (
                  <Option key={idx} value={item?.id}>
                    {nameAddress + " " + item?.street + " " + item?.house_number + " " + item?.zip + " " + item?.city}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="product_location"
              label={t("location_from_product")}
              labelAlign="left"
            >
              <Input placeholder="" disabled={!isEdit} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={6}>
            <Form.Item name="files" label={t("upload_files")} labelAlign="left">
              <Upload
                customRequest={({ file, onSuccess }) => {
                  setTimeout(() => {
                    onSuccess("ok");
                  }, 0);
                }}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>{t("upload_image")}</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={16}>
          <Col span={6}>
            <Image src={ApiConstants.IMAGE_URL} width={100} />
            <Upload {...props}>
              <Button
                icon={<UploadOutlined />}
                style={{
                  paddingTop: "30px",
                  paddingBottom: "55px",
                  paddingLeft: "40px",
                  paddingRight: "40px",
                }}
              >
                {t("upload_image")}
              </Button>
            </Upload>
          </Col>
        </Row> */}
      </Form>
    </Drawer>
  );
};
